import { PlanDurationMetric } from "../enums";
import { PlanDurationMetricLabels } from "../labels";

export const getPlanDurationMetricTypes = () => [
  {
    id: PlanDurationMetric.Days,
    name: PlanDurationMetricLabels[PlanDurationMetric.Days],
  },
  {
    id: PlanDurationMetric.Months,
    name: PlanDurationMetricLabels[PlanDurationMetric.Months],
  },
  {
    id: PlanDurationMetric.Years,
    name: PlanDurationMetricLabels[PlanDurationMetric.Years],
  },
];
